import React from 'react';
import {
  Tabs,
  Tab,
  Badge,
  Box
} from '@mui/material';
import {
  List as AllIcon,
  HourglassEmpty as PendingIcon,
  Payment as ReadyIcon,
  CheckCircle as PaidIcon,
  Work as WorkIcon
} from '@mui/icons-material';

interface PayrollTabsProps {
  activeTab: number;
  onTabChange: (newTab: number) => void;
  totalPayrolls: number;
  readyForPayment: number;
  paidCount: number;
  completedWorkCount: number;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanel: React.FC<TabPanelProps> = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`payroll-tabpanel-${index}`}
      aria-labelledby={`payroll-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
};

export const PayrollTabs: React.FC<PayrollTabsProps> = ({
  activeTab,
  onTabChange,
  totalPayrolls,
  readyForPayment,
  paidCount,
  completedWorkCount
}) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
      <Tabs 
        value={activeTab} 
        onChange={(_, newValue) => onTabChange(newValue)}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab
          icon={<AllIcon />}
          label={
            <Badge badgeContent={totalPayrolls} color="primary" showZero>
              All Payrolls
            </Badge>
          }
          iconPosition="start"
          sx={{ minHeight: 'auto', py: 2 }}
        />
        <Tab
          icon={<ReadyIcon />}
          label={
            <Badge badgeContent={readyForPayment} color="success" showZero>
              Ready for Payment
            </Badge>
          }
          iconPosition="start"
          sx={{ minHeight: 'auto', py: 2 }}
        />
        <Tab
          icon={<PaidIcon />}
          label={
            <Badge badgeContent={paidCount} color="default" showZero>
              Completed Payments
            </Badge>
          }
          iconPosition="start"
          sx={{ minHeight: 'auto', py: 2 }}
        />
        <Tab
          icon={<WorkIcon />}
          label={
            <Badge badgeContent={completedWorkCount} color="info" showZero>
              Completed Work
            </Badge>
          }
          iconPosition="start"
          sx={{ minHeight: 'auto', py: 2 }}
        />
      </Tabs>
    </Box>
  );
};
